import { cva, type VariantProps } from 'class-variance-authority'
import type { ReactNode } from 'react'

import { cn } from '../../lib/utils'
import { Container, type ContainerProps } from './container'
import { Stack, type StackProps } from './stack'

const pageShellDensityVariants = cva('', {
  variants: {
    density: {
      compact: 'py-2 md:py-4',
      default: 'py-4 md:py-6',
      comfortable: 'py-6 md:py-8',
    },
  },
  defaultVariants: {
    density: 'default',
  },
})

type PageShellWidth = NonNullable<ContainerProps['size']>
type PageShellContentSize = NonNullable<StackProps['size']>

interface PageShellProps extends VariantProps<typeof pageShellDensityVariants> {
  children: ReactNode
  width?: PageShellWidth
  contentSize?: PageShellContentSize
  className?: string
  contentClassName?: string
}

function PageShell({
  children,
  width = 'wide',
  density = 'default',
  contentSize = 'md',
  className,
  contentClassName,
}: PageShellProps) {
  return (
    <div
      data-slot="page-shell"
      data-density={density ?? 'default'}
      className={cn('flex-1', className)}
    >
      <Container
        size={width}
        className={cn('app-page-container', pageShellDensityVariants({ density }))}
      >
        <Stack size={contentSize} className={cn('app-page-stack', contentClassName)}>
          {children}
        </Stack>
      </Container>
    </div>
  )
}

export { PageShell, type PageShellProps }
